import React from "react";
import {useDispatch} from "react-redux";

// Components
import SelectInput from "./select-input";

// Hooks
import {useAuth} from "../../auth/auth";
import {useUserClientsData} from "../../user-clients-data/user-clients-data";
import {useTranslation} from "react-i18next";
import {useFilters} from "../../filters/filters";

// Actions
import {cleanStocksState} from "../../stocks/stocks-actions";
import {cleanInvoicesStatsState} from "../../home/invoices-stats-actions";
import {cleanDeliveryNotesStatsState} from "../../home/delivery-notes-stats-actions";
import {cleanInvoicesState} from "../../invoices/invoices-actions";
import {cleanDeliveryNotesState} from "../../delivery-notes/delivery-notes-actions";
import {cleanTechnicalsSheetsState} from "../../technical-sheets/technicals-sheets-actions";

// Redux dispatch hook
const useReduxDispatch = () => {
    const dispatch = useDispatch();
    return {
        cleanStocksState: () => dispatch(cleanStocksState()),
        cleanInvoicesStatsState: () => dispatch(cleanInvoicesStatsState()),
        cleanDeliveryNotesStatsState: () => dispatch(cleanDeliveryNotesStatsState()),
        cleanInvoicesState: () => dispatch(cleanInvoicesState()),
        cleanDeliveryNotesState: () => dispatch(cleanDeliveryNotesState()),
        cleanTechnicalsSheetsState: () => dispatch(cleanTechnicalsSheetsState())
    }
};

const ClientSelector = (props) => {

    // Redux
    const {
        cleanStocksState,
        cleanInvoicesStatsState,
        cleanDeliveryNotesStatsState,
        cleanInvoicesState,
        cleanDeliveryNotesState,
        cleanTechnicalsSheetsState
    } = useReduxDispatch();

    // filters
    const {
        removeInvoicesFilters,
        removeDeliveryNotesFilters,
        removeTechnicalSheetsFilters
    } = useFilters();

    // Selected client management
    const {selectedClient, setSelectedClient} = useAuth();
    const {userClientsData} = useUserClientsData();
    const {t} = useTranslation();

    const clients = userClientsData.map(d => ({
        value: d._id,
        label: d.name
    }));

    return (
        <SelectInput
            options={clients}
            name={"clientSelector"}
            label={t("selectClient")}
            placeholder={t("selectClientPlaceholder")}
            onChange={(newSelectedClient) => {
                // clean state and remove filters from localStorage when change the selected client
                cleanStocksState();
                cleanInvoicesStatsState();
                cleanDeliveryNotesStatsState();
                cleanInvoicesState();
                cleanDeliveryNotesState();
                cleanTechnicalsSheetsState();
                removeInvoicesFilters();
                removeDeliveryNotesFilters();
                removeTechnicalSheetsFilters();
                setSelectedClient(newSelectedClient.value);
            }}
            value={clients.find(client => client.value === selectedClient)}
            style={{marginRight: 15, ...props.style}}
        />
    );

};

export default ClientSelector;